<template>
    <UModal :model-value="open" @update:model-value="$emit('update:open', $event)">
        <UCard :ui="{ rounded: 'rounded-lg', body: { base: 'overflow-visible' } }">
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-base font-medium leading-6 text-gray-800">Create Feedback Report</h3>
                    <UButton color="gray" variant="ghost" icon="i-ph-x-bold" class="-my-1" @click="dismiss()" />
                </div>
            </template>
            <UFormGroup label="Notes">
                <UTextarea v-model="notes" :rows="5" size="xl" placeholder="e.g. Called 48h after intervention, patient doing well" />
            </UFormGroup>
            <template #footer>
                <div class="flex items-center justify-end space-x-2">
                    <UButton size="lg" color="white" label="Cancel" @click="dismiss()" />
                    <UButton size="lg" color="black" label="Save" :loading="saving" :disabled="!notes.trim()" @click="confirm()" />
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
const props = defineProps<{
    open: boolean
    interventionId: string
}>()

const emit = defineEmits<{
    'update:open': [boolean]
    'reload': [void]
}>()

const client = useSupabaseClient()
const toast = useToast()

const notes = ref('')
const saving = ref(false)

watch(() => props.open, (open) => {
    if (open) notes.value = ''
})

async function confirm() {
    saving.value = true
    const { error } = await client.from('intervention_reports').insert({
        intervention_id: props.interventionId,
        notes: notes.value.trim(),
    } as never)
    saving.value = false

    if (error) {
        toast.add({ title: 'Could not create the feedback report.', description: error.message, color: 'red', icon: 'i-ph-x-circle-duotone' })
        return
    }

    toast.add({ title: 'Feedback report created.', color: 'green', icon: 'i-ph-check-circle-duotone' })
    emit('reload')
    dismiss()
}

function dismiss() {
    emit('update:open', false)
}
</script>
